import { render, staticRenderFns } from "./DisplayPage.vue?vue&type=template&id=24dffe6b&scoped=true"
import script from "./DisplayPage.vue?vue&type=script&lang=js"
export * from "./DisplayPage.vue?vue&type=script&lang=js"
import style0 from "./DisplayPage.vue?vue&type=style&index=0&id=24dffe6b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dffe6b",
  null
  
)

export default component.exports